import { render, staticRenderFns } from "./ButtonSwitchCorporate.vue?vue&type=template&id=e6c5901a&scoped=true&"
import script from "./ButtonSwitchCorporate.vue?vue&type=script&lang=ts&"
export * from "./ButtonSwitchCorporate.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonSwitchCorporate.vue?vue&type=style&index=0&id=e6c5901a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c5901a",
  null
  
)

export default component.exports